import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Actions from '../../actions/actions';

const AuthLink = function (props) {
  const {
    anon, to, children, authVm: { uid, emailVerified }
  } = props;

  if ((!anon && uid !== undefined && emailVerified) || (anon && (uid === undefined || !emailVerified))) {
    return (
      <Link to={to}>
        {children}
      </Link>
    );
  }
  return null;
};

export default connect(
  state => ({ ...state.authReducer }),
  dispatch => (bindActionCreators(Actions, dispatch))
)(AuthLink);



// WEBPACK FOOTER //
// ./src/pages/Header/AuthLink.js